export default [{
    text: 'Поселений',
    value: 'settlements'
}, {
    text: 'Сельскохозяйственного назначения',
    value: 'forAgriculturalPurposes'
}, {
    text: 'Промышленности, энергетики, транспорта, связи и иного не сельхоз. назначения',
    title: 'Промышленности...',
    value: 'industryTransportCommunications'
}];
